<div class="card mb-3 border-0 shadow-sm">
  <div class="card-header bg-secondary text-white d-flex align-items-center gap-2">
    <i class="bx bx-group bx-sm"></i>
    <strong>Antecedentes Familiares</strong>
    <span class="badge bg-light text-dark ms-auto">{{ familyHistories().length }}</span>
  </div>
  <div class="card-body p-0">
    <div class="list-group list-group-flush">
      @for (fh of familyHistories(); track fh.id) {
        <div class="list-group-item">
          <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
            <div>
              <strong>{{ getRelationship(fh) }}</strong>
            </div>
            @if (getStatus(fh)) {
              @let badge = getStatusBadge(getStatus(fh));
              <span class="badge {{ badge.color }}">{{ badge.label }}</span>
            }
          </div>

          @if (getConditions(fh).length > 0) {
            <div class="mt-2">
              <small class="text-muted d-block mb-1">Condiciones:</small>
              <div class="d-flex flex-wrap gap-1">
                @for (cond of getConditions(fh); track $index) {
                  <span class="badge bg-light text-dark border">
                    {{ getConditionName(cond) }}
                  </span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
